const Lb = () => import(/* webpackChunkName: "lb-group" */ '@/views/lb/Lb')

export default [
  {
    path: 'lb',
    name: 'lb',
    components: {
      studyContent: Lb
    },
    meta: {
      title: '实验室检查参考值'
    }
  }
]
